import Backbone from 'backbone-associations';
import { truncate } from 'lodash';
import moment from 'moment';

import path from 'js/lib/path';

import constants from 'pages/open-course/common/constants';
import SocialProfile from 'pages/open-course/common/models/socialProfile';

const PeerReviewSubmissionSummary = Backbone.AssociatedModel.extend({
  relations: [
    {
      type: Backbone.One,
      key: 'creator',
      relatedModel: SocialProfile,
    },
  ],

  getReviewLink() {
    return path.join(this.collection.getItemLink(), 'review', this.get('id'));
  },

  getTimestampString() {
    return (this.timestampString = moment(this.get('createdAt')).fromNow());
  },

  getUserName() {
    return this.get('creator.fullName');
  },

  getUserPhoto() {
    return this.get('creator.photoUrl');
  },

  getTruncatedTitle() {
    return truncate(this.get('title'), {
      length: constants.gallery.maxTitleLength,
      separator: ' ',
      omission: '…',
    });
  },
});

export default PeerReviewSubmissionSummary;
